<template>
  <div id="app">
    <Main />
  </div>
</template>

<script>
import Main from './components/Main'

export default {
  name: 'app',
  components: {
    Main
  }
}
</script>

<style lang="stylus">
html, body
  padding: 0
  margin: 0
  background-color: #000

#app
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
</style>
